import { IReservationModel, ReservationModel } from "@common/models";

export interface IRebookReservationResponse {
    reservation: IReservationModel | undefined;
    reschedulingSystemUrl: string;
}

export class RebookReservationResponse implements Record<keyof IRebookReservationResponse, any> {
    reservation: ReservationModel | undefined;
    reschedulingSystemUrl: string;

    constructor(params: IRebookReservationResponse) {

        this.reservation = params.reservation ? new ReservationModel(params.reservation) : undefined;
        this.reschedulingSystemUrl = params.reschedulingSystemUrl;
    }
}
